module.exports = __webpack_public_path__ + "img/hph.d4ce04bf.jpg";